import React from 'react';

const AirplaneTicketIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      {...props}
    >
      <path
        fill="currentColor"
        d="M357.077-343.231l348.308-92.461q13.461-3.231 21.346-14.654 7.884-11.423 4.654-24.116-3.231-12.692-15.193-17.884-11.961-5.193-24.654-1.962l-101.076 27.539-160-150-42.154 9.384 96 168-109.846 27.077-50-38-24.154 6.923 56.769 100.154zM775.385-200h-590.77q-26.846 0-45.731-18.884Q120-237.769 120-264.615v-103.078q35.307-13.076 57.654-43.499Q200-441.615 200-480q0-38.385-22.346-68.808-22.347-30.423-57.654-43.499v-103.078q0-26.846 18.884-45.731Q157.769-760 184.615-760h590.77q26.846 0 45.731 18.884Q840-722.231 840-695.385v430.77q0 26.846-18.884 45.731Q802.231-200 775.385-200zm0-40q10.769 0 17.692-6.923T800-264.615v-430.77q0-10.769-6.923-17.692T775.385-720h-590.77q-10.769 0-17.692 6.923T160-695.385V-618q37 22 58.5 58.5T240-480q0 43-21.5 79.5T160-342v77.385q0 10.769 6.923 17.692T184.615-240h590.77zM480-480z"
      ></path>
    </svg>
  );
};

export default AirplaneTicketIcon;
